import axios from "axios";
import { API_CONFIG } from "../config";

interface LoginResponse {
  data: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    isActive: boolean;
    role: string;
    token?: string;
    businesses?: Array<{
      id: string;
      name: string;
    }>;
  };
}

class LoginApi {
  /**
   * Authenticate user with username and password
   */
  static async login(
    username: string,
    password: string
  ): Promise<LoginResponse> {
    try {
      const response = await axios.post(
        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.AUTHENTICATE}`,
        { username, password },
        {
          headers: {
            accept: "application/json",
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      // Debug: Log the actual response to see its structure
      console.log("API Response:", response);
      console.log("Response Data:", response.data);

      // Check if response.data exists
      if (!response.data) {
        throw new Error("No data received from authentication API");
      }

      return response.data;
    } catch (error: any) {
      console.error("Login error:", error);
      console.error("Error response:", error.response?.data?.data?.message);
      throw new Error(error.response?.data?.data?.message || "Login failed");
    }
  }
}

export default LoginApi;
